import script from "./AdminMasterclass.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMasterclass.vue?vue&type=script&setup=true&lang=js"

import "./AdminMasterclass.vue?vue&type=style&index=0&id=9a917d62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a917d62"]])

export default __exports__